/// <amd-module name="Wit/Common/WorkItemDialogs/clients/WorkItemTracking" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\wit\vss-work-web\common\components\work-item-dialogs\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as WorkItemTracking_Contracts from "Wit/Clients/Wit/Contracts/WorkItemTracking";

import { IWorkItemTrackingRestClient } from "Wit/Common/WorkItemDialogs/clients/WorkItemTracking.Types";

export { IWorkItemTrackingRestClient } from "Wit/Common/WorkItemDialogs/clients/WorkItemTracking.Types";

class WorkItemTrackingRestClient extends RestClientBase implements IWorkItemTrackingRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * RESTful method to send mail for selected/queried work items.
     * 
     * @param body - 
     * @param project - Project ID or project name
     */
    public async sendMail(
        body: WorkItemTracking_Contracts.SendMailBody,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/wit/sendMail",
            routeValues: {
                project: project
            },
            body: body
        });
    }

}

export const WorkItemTrackingClientName = "WorkItemDialogs-Wit.IWorkItemTrackingRestClient";

export function getWorkItemTrackingClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IWorkItemTrackingRestClient {
    return pageContext.getRestClient<IWorkItemTrackingRestClient>(WorkItemTrackingClientName, options);
}

RestClients.add(WorkItemTrackingClientName, { 
    factory: WorkItemTrackingRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
